<template>
  <div>
    <top-nav></top-nav>
    <div class="center_container">
      <div class="crumb">社会体育指导员</div>
      <div class="info">
        <div class="info_img">
          <img src="../../assets/image/instructor/del_img.png" />
        </div>
        <div class="info_right">
          <div class="info_name">林克芳</div>
          <div class="info_item">性别：女</div>
          <div class="info_item">联系方式：16547368267</div>
          <div class="info_item">技术等级：跆拳道黑带</div>
          <div class="info_type">
            <div v-for="(item, index) in types" :key="index">{{ item }}</div>
          </div>
          <div class="info_title">个人简介</div>
          <div class="info_content">林丹，汉族，1983年10月14日出生于福建省龙岩市上杭县临江镇，中国羽毛球男单运动员， [2] [131] 现已退役。 [12]
            因其在各项世界比赛中夺冠，长时间占据世界排名第一，被称为“超级丹”（SUPER DAN）。 [131] [136]<br>
            林丹于1988年开始接触羽毛球，2000年进入国家队， [131] 2002年8月首次登上羽毛球世界排名第一的位置， [2] 2005年12月获首个单项世界冠军（世界杯），并于2006年卫冕。 [10] [133]
            2008年北京奥运会、2012年伦敦奥运会，获羽毛球男单冠军。 [3-4]2006、2007、2009、2011、2013年，五次获世锦赛男单冠军。 [5] 2004、2006、 [29] 2008、 [39]
            2010、 [54] 2012、 [69] 2018年， [10] 六次获汤姆斯杯冠军。2005、 [27] 2007、 [34] 2009 [45] 、2011、 [134] 2015年 [84]
            ，五次获苏迪曼杯冠军。2004、 [33] 2006、2007、2009、2012、2016年， [13] 六次获全英赛冠军。其于2009年实现“全满贯”， [3] 2014年实现双圈“全满贯”， [6]
            职业生涯共66个冠军头衔，其中世界冠军20个。 [117] [135]<br>
            林丹左手握拍，以拉吊突击为主打法，进攻意识强，场上速度快，进攻落点好，攻击犀利，步伐灵活，扣杀较具有威胁。 [2] 林丹与李宗伟的比赛，被称为“林李大战”，两人代表了他们那个时代世界羽毛球领域男子单打的最高水平。
            [137] 对阵次数40次，林丹28胜12负。 [136] 随着李宗伟宣布退役，“林李大战”成为历史。 [138]<br>
            林丹是羽毛球史上第一位集奥运会、世锦赛、世界杯、苏迪曼杯、汤姆斯杯、亚运会、亚锦赛、全英赛、全运会及多座世界羽联超级系列赛冠军于一身的双圈全满贯选手。 [132] 被誉为中国羽球一哥、世界羽毛球四大天王之一，
            [133] 并于2023年5月入选羽联名人堂。 [130]
          </div>
        </div>
      </div>
      <div class="info_title">个人履历</div>
      <div class="info_content" style="margin-bottom: 44px">
        （2002年-2004年）<br>
        2002年3月，林丹参加全英羽毛球公开赛并获得男单第3名。 [13] 3月31日，在韩国南部城市丽水举行的韩国羽毛球公开赛上，代表中国队出战的林丹在男子单打决赛中以3:1战胜韩国队的孙升模并获得冠军。 [14] 5月，林丹以第三单打身份参加汤姆斯杯。 [158] 8月22日，不满19岁的林丹登上国际羽联排名第一的位置并保持一周的时间。 [2]
        <br><br>
        （2005年-2007年）<br>
        2005年3月13日，林丹在全英赛决赛中输给了队友陈宏，未能卫冕。 [13] [26] 5月15日，林丹和队友合作以3∶0的大比分轻取印尼队，将2003年被韩国队夺走的苏迪曼杯重新夺了回来。 [27] 8月22日，羽毛球世锦赛男子单打决赛，林丹输给了印度尼西亚天才球手陶菲克。 [28] 12月，世界羽联恢复举办世界杯，林丹顺利闯入决赛并以2:0战胜雅典奥运会第四名泰国名将文萨·波萨那，夺取了他个人第一个世界冠军头衔。
      </div>

      <div class="info_title">评论</div>
      <div class="comment_list">
        <div v-for="item in 6" :key="item" class="comment_item">
          <div class="display_flex i_top">
            <div>会员23987864</div>
            <div class="i_time">2023-07-24 17:57:53</div>
          </div>
          <div class="i_con">
            非常好的场馆非常好的场馆非常好的场馆非常好的场馆非常好的场馆非常好的场馆，非常好的场馆非常好的场馆非常好的场馆非常好的场馆，非常好的场馆非常好的场馆非常好的场馆非常好的场馆非常好的场馆，非常
            好的场馆非常好的场馆，非常好的场馆非常好的场馆。
          </div>
        </div>
      </div>
    </div>
    <bot-nav></bot-nav>
  </div>
</template>

<script>
export default {
  name: "instructorDetails",
  data () {
    return {
      types: ['跆拳道', '篮球', '足球', '瑜伽', '健身']
    }
  }
}
</script>

<style lang="less" scoped>
.center_container {
  padding-bottom: 44px;
}

.info_title {
  font-weight: 500;
  font-size: 24px;
  color: #0058A6;
  margin-bottom: 9px;
}

.info_content {
  font-size: 20px;
  line-height: 32px;
}

.info {
  display: flex;
  margin-bottom: 44px;

  .info_img {
    width: 25%;
    min-width: 25%;
    margin-right: 40px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .info_right {
    .info_name {
      font-weight: 700;
      font-size: 24px;
      margin-bottom: 24px;
    }

    .info_item {
      font-size: 18px;
      margin-bottom: 16px;
    }

    .info_type {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 35px;

      div {
        padding: 8px 21px;
        background: #0058a626;
        font-size: 14px;
        color: #0058A6;
        margin: 0 6px 6px 0;
      }
    }
  }
}
</style>
